import { useState, useEffect } from "react";
import Swal from "sweetalert2"; 
import { getCompanyMasterByRefID, postCompanyMaster } from "../api/golfClubAPI";
import swal from 'sweetalert2';

const AddGSTNumber = ({ setSelectCompany, refID, selectCompany, onDismissModal }) => {
    const [gstDetails, setGstDetails] = useState({});
    const [gstList, setGstList] = useState([]);
 
    useEffect(() => {
        $('#modalGST').modal({
            backdrop: 'static',
        });
        $('#modalGST').on('hidden.bs.modal', function () {
            $('.modal').hasClass('show') && $('body').addClass('modal-open');
            onDismissModal(false);
        }); 
      
    }, [])

    useEffect(() => {
      if(refID != null) fetchCompanyMaster(refID)
    }, [refID])
 
    useEffect(() => {
      if(!!selectCompany) setGstDetails(selectCompany)
    }, [selectCompany])

    const updateGSTDetails = (field, value) => {
        setGstDetails((prev) => ({ ...prev, [field]: value }));
    };

    const fetchCompanyMaster = async (refID) => {
        try {
            const master = await getCompanyMasterByRefID(refID);
            setGstList(master); 
        } catch (error) {
            swal.fire({ icon: 'error', titleText: error.message });
        }
    };

    const saveGSTHandler = async(e) => {
        e.preventDefault();
        if (!gstDetails.CompanyName || !gstDetails.GSTNumber) {
            Swal.fire({ icon: "error", title: "Error!", text: "Please fill in all required fields" });
            return;
        }
        const res = await postCompanyMaster({...gstDetails, RefID: refID, Active: "Y"})
        setSelectCompany(res);
        $('#modalGST').modal('hide');
        Swal.fire({ icon: "success", title: "Saved!", text: "GST details added successfully", timer: 1500 });
    };
    
    const selectGST = (company) => {
        setSelectCompany(company); 
        $('#modalGST').modal('hide');
    };
    const remove = () => {
        setSelectCompany({}); 
        onDismissModal(false);
        $('#modalGST').modal('hide');
    };

    return (
        <div id="modalGST" className="modal fade modal-responsive" tabIndex="-1" role="dialog">
            <div className="modal-dialog modal-lg" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Add GST Number</h5>
                        <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                            <span>&times;</span>
                        </button>
                    </div>
                    <div className="modal-body margin-20">
                    <form className="kt-form" id="add-gst-form" >
                        <div id="ModalGSTHolder" className="kt-form kt-form--label-right" role="form">
                            <center><h5>New Company</h5></center>
                            <div className="form-group row padding-t5">
                                <label className="col-form-label col-lg-3">Company Name <span className="red">*</span></label>
                                <div className="col-xl-6 col-lg-8">
                                <input 
                                    id="txtCompanyName" 
                                    name="txtCompanyName" 
                                    type="text" 
                                    className="form-control" 
                                    value={gstDetails.CompanyName || ''}
                                    onChange={(event) => updateGSTDetails("CompanyName", event.target.value)} 
                                />
                                </div>
                            </div>

                            <div className="form-group row">
                                <label className="col-form-label col-lg-3">GST Number <span className="red">*</span></label>
                                <div className="col-xl-6 col-lg-8">
                                <input 
                                    id="txtGSTNumber" 
                                    name="txtGSTNumber" 
                                    type="text" 
                                    className="form-control"
                                    value={gstDetails.GSTNumber || ''}
                                    onChange={(event) => updateGSTDetails("GSTNumber", event.target.value)} 
                                />
                                </div>
                            </div>

                            <div className="form-group row">
                                <label className="col-form-label col-lg-3">Address</label>
                                <div className="col-xl-6 col-lg-8">
                                <textarea 
                                    id="txtAddress" 
                                    name="txtAddress" 
                                    className="form-control"
                                    value={gstDetails.Address || ''}
                                    onChange={(event) => updateGSTDetails("Address", event.target.value)}
                                />
                                </div>
                            </div>
                        </div>
                    </form>
                        {gstList.length > 0 && (
                            <>
                            <center><h5>Select Company </h5></center>
                            <hr />
                            <table className="table table-bordered table-hover margin-b30">
                                <thead  className="light-grey-background">
                                    <tr>
                                        <th>Company Name</th>
                                        <th>GST Number</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {gstList.map((company, index) => (
                                        <tr key={index} onClick={() => selectGST(company)} style={{ cursor: "pointer" }}>
                                            <td>{company.CompanyName}</td>
                                            <td>{company.GSTNumber}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            </>
                        )}
                    </div>
                    <div className="modal-footer">
                        <button type="button" id="btnSaveGuest" name="btnSaveGuest" className="btn btn-brand margin-0 margin-r5" onClick={saveGSTHandler}>Add</button>
                        {selectCompany?.ID && (<button type="button" id="btnremoveGuest" name="btnremoveGuest" className="btn btn-danger margin-0 margin-r5" onClick={remove}>Remove</button>)}
                        <button type="button" className="btn btn-secondary margin-0 margin-r5" data-dismiss="modal">Close</button>

                    </div>
                </div>
            </div>
        </div>
    );
};

export default AddGSTNumber;